if (!customElements.get('bundle-product')) {
  class BundleProduct extends HTMLElement {
    connectedCallback() {
      this.productData = this._getProductData();
      if (!this.productData) return;

      this.optionSelects = this.querySelectorAll('[data-element="option-select"]');
      this.image        = this.querySelector('[data-element="image"]');
      this.price        = this.querySelector('[data-element="price"]');
      this.comparePrice = this.querySelector('[data-element="compare-price"]');
      this.button       = this.querySelector('[data-element="add-button"]');
      this.removeButton = this.querySelector('[data-element="remove-button"]');
      this.customFields = this.querySelectorAll('[data-element="custom-field"]');

      this.artContainer = document.getElementById(`Art-container-${this.productData.id}`);
      this.optionSelects = this.querySelectorAll('[data-element="option-select"]');
      this.styleSelect = this.querySelector('select[data-element="custom-field"][data-type="style"]');

      this.variant = this.productData.variants.find(v => v.available) || this.productData.variants[0];
      this.isRemoved = false;
      

      this.optionSelects.forEach(select => {
        select.addEventListener('change', this._onOptionsChange.bind(this));
      });

      if (this.styleSelect) {
        this.styleSelect.addEventListener('change', this._onOptionsChange.bind(this));
      }
      if (this.button)       this.button.addEventListener('click', this._onAddToCart.bind(this));
      if (this.removeButton) this.removeButton.addEventListener('click', this._onRemoveProduct.bind(this));

      this._updateDOM();
      this._updateArtContainer();
    }

    _getProductData() {
      try {
        const json = this.querySelector('[data-element="product-json"]');
        return JSON.parse(json.textContent);
      } catch (e) {
        console.error(e);
        return null;
      }
    }

    _onOptionsChange() {
      const selectedOptions = Array.from(this.optionSelects).map(select => select.value);
      const matchingVariant = this.productData.variants.find(variant => {
        return variant.options.every((value, index) => value === selectedOptions[index]);
      });
      this._updateArtContainer();
      if (matchingVariant) {
        this.variant = matchingVariant;
        this._updateDOM();
        this._notifyPriceChange();
      }
    }

    _updateArtContainer() {
      if (!this.artContainer) return;
      let frameValue = '', sizeValue = '', styleValue = '';


      this.optionSelects.forEach(select => {
        const type = select.getAttribute('data-type');
        const selectedOption = select.options[select.selectedIndex];
        const dataValue = selectedOption.getAttribute('data-value') || selectedOption.value;
        if (type === 'frame') frameValue = dataValue;
        if (type === 'size')  sizeValue  = dataValue;
      });

      if (this.styleSelect) {
        const selectedOption = this.styleSelect.options[this.styleSelect.selectedIndex];
        styleValue = selectedOption.getAttribute('data-value') || selectedOption.value;
      }

      if (frameValue) this.artContainer.setAttribute('data-frame', frameValue);
      if (sizeValue)  this.artContainer.setAttribute('data-size',  sizeValue );
      if (styleValue) this.artContainer.setAttribute('data-style', styleValue);

      
      const frameSelect = this.querySelector('select[data-type="frame"]');
      if (frameSelect && this.styleSelect) {
        const frameSelectedOption = frameSelect.options[frameSelect.selectedIndex];
        if (frameSelectedOption.getAttribute('data-value') === 'option-1-5') {
          const option31 = Array.from(this.styleSelect.options).find(opt => opt.getAttribute('data-value') === 'option-3-1');
          if (option31) {
            option31.disabled = true;
            
            if (this.styleSelect.selectedIndex > -1 && this.styleSelect.options[this.styleSelect.selectedIndex].getAttribute('data-value') === 'option-3-1') {
              const option30 = Array.from(this.styleSelect.options).find(opt => opt.getAttribute('data-value') === 'option-3-0');
              if (option30) {
                this.styleSelect.value = option30.value;
                this.styleSelect.dispatchEvent(new Event('change', {bubbles:true}));
              }
            }
          }
        } else {
          const option31 = Array.from(this.styleSelect.options).find(opt => opt.getAttribute('data-value') === 'option-3-1');
          if (option31) option31.disabled = false;
        }
      }
    }
    

    _updateDOM() {
      const variant = this.variant;
      const currencyFormat = window.theme.settings.money_with_currency_format || "${{amount}}";
      if (!variant) return;

      if (this.price) {
        this.price.innerHTML = formatMoney(variant.price, currencyFormat);
      }
      if (this.comparePrice) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          this.comparePrice.innerHTML = formatMoney(variant.compare_at_price, currencyFormat);
          this.comparePrice.classList.remove('hidden');
        } else {
          this.comparePrice.classList.add('hidden');
        }
      }
      if (variant.featured_image?.src && this.image) {
        this.image.src = variant.featured_image.src.replace(/(\?|$)/, '_160x$1');
        this.image.srcset = variant.featured_image.srcset.replace(/(\?|$)/, '_160x$1');
        this.image.alt = variant.title;
      }
      if (this.button) {
        this.button.dataset.variantId = variant.id;
        this.button.disabled = !variant.available || this.isRemoved;
      }
      this._updateRemovedState();
    }

    _updateRemovedState() {
      if (this.isRemoved) {
        this.classList.add('bundle-product--removed');
        this.setAttribute('aria-hidden', 'true');
        this.optionSelects.forEach(select => select.disabled = true);
        this.customFields.forEach(field => field.disabled = true);
        if (this.button) this.button.disabled = true;
        if (this.removeButton) {
          const buttonText = this.removeButton.querySelector('span');
          if (buttonText) buttonText.textContent = window.bundleProductStrings.addBackProduct;
        }
      } else {
        this.classList.remove('bundle-product--removed');
        this.removeAttribute('aria-hidden');
        this.optionSelects.forEach(select => select.disabled = false);
        this.customFields.forEach(field => field.disabled = false);
        if (this.button) this.button.disabled = !this.variant.available;
        if (this.removeButton) {
          const buttonText = this.removeButton.querySelector('span');
          if (buttonText) buttonText.textContent = window.bundleProductStrings.removeProduct;
        }
      }
    }

    _onRemoveProduct() {
      this.isRemoved = !this.isRemoved;
      this._updateDOM();
      this._notifyPriceChange();
      this.dispatchEvent(new CustomEvent('bundle-product:toggle', {
        detail: { 
          removed: this.isRemoved,
          productId: this.productData.id,
          productTitle: this.productData.title
        },
        bubbles: true
      }));
    }

    _notifyPriceChange() {
      const bundleManager = this.closest('bundle-manager');
      if (bundleManager) bundleManager.updateSubTotal();
    }

    // Lấy custom fields: name property chuẩn Shopify (ví dụ: properties[Gift Wrap])
    _getCustomFieldsData() {
      const customData = {};
      this.customFields.forEach(field => {
        let name = field.name;
        if (!name) {
          name = `properties[${field.getAttribute('data-property-name') || field.id || 'custom'}]`;
        }
        if (name.startsWith('properties[')) {
          let value = '';
          if (field.type === 'checkbox') {
            value = field.checked ? field.value : '';
          } else if (field.type === 'radio') {
            if (field.checked) value = field.value;
          } else {
            value = field.value;
          }
          const match = name.match(/^properties\[(.*)\]$/);
          if (match && value) {
            customData[match[1]] = value;
          }
        }
      });
      return customData;
    }

    _validateCustomFields() {
      const errors = [];
      this.customFields.forEach(field => {
        if (field.hasAttribute('required') && !field.value.trim()) {
          const label = field.getAttribute('data-label') || field.name || 'Trường thông tin';
          errors.push(`${label} là bắt buộc`);
        }
      });
      return errors;
    }

    getCurrentVariant() {
      return this.variant;
    }
    getCurrentPrice() {
      return (this.variant && !this.isRemoved) ? this.variant.price : 0;
    }
    isAvailable() {
      return this.variant && this.variant.available && !this.isRemoved;
    }
    isProductRemoved() {
      return this.isRemoved;
    }
    restoreProduct() {
      if (this.isRemoved) {
        this.isRemoved = false;
        this._updateDOM();
        this._notifyPriceChange();
      }
    }
    removeProduct() {
      if (!this.isRemoved) {
        this.isRemoved = true;
        this._updateDOM();
        this._notifyPriceChange();
      }
    }

    async addToCartSilent(quantity = 1) {
      const variantId = this.variant?.id;
      if (!variantId || !this.variant.available || this.isRemoved) {
        throw new Error(`${window.bundleProductStrings.noAvailableProducts}`);
      }
      const validationErrors = this._validateCustomFields();
      if (validationErrors.length > 0) {
        throw new Error(validationErrors.join(', '));
      }
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', quantity);

      const customFieldsData = this._getCustomFieldsData();
      Object.keys(customFieldsData).forEach(key => {
        formData.append(`properties[${key}]`, customFieldsData[key]);
      });

      if (cart?.getSectionsToRender) {
        const sections = cart.getSectionsToRender().map(section => section.id);
        formData.append('sections', sections.join(','));
        formData.append('sections_url', window.location.pathname);
        cart.setActiveElement?.(document.activeElement);
      }

      const res = await fetch(`${routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      });
      if (!res.ok) throw new Error(await res.text());
      const data = await res.json();
      if (data.status) throw new Error(data.message || data.description);
      return { data, cart };
    }

    async _onAddToCart() {
      const variantId = parseInt(this.button.dataset.variantId);
      if (!variantId || this.button.disabled || this.isRemoved) return;

      const validationErrors = this._validateCustomFields();
      if (validationErrors.length > 0) {
        alert(validationErrors.join('\n'));
        return;
      }

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const spinner = this.button.querySelector('.loading__spinner');
      this.button.classList.add('loading');
      this.button.setAttribute('aria-disabled', true);
      spinner?.classList.remove('hidden');

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);

      const customFieldsData = this._getCustomFieldsData();
      Object.keys(customFieldsData).forEach(key => {
        formData.append(`properties[${key}]`, customFieldsData[key]);
      });

      if (cart?.getSectionsToRender) {
        const sections = cart.getSectionsToRender().map(section => section.id);
        formData.append('sections', sections.join(','));
        formData.append('sections_url', window.location.pathname);
        cart.setActiveElement?.(document.activeElement);
      }

      try {
        const res = await fetch(`${routes.cart_add_url}.js`, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        });
        if (!res.ok) throw new Error(await res.text());
        const data = await res.json();
        if (data.status) return;
        if (cart?.renderContents) {
          cart.renderContents(data);
        } else {
          window.location = window.routes.cart_url;
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.button.classList.remove('loading');
        this.button.removeAttribute('aria-disabled');
        spinner?.classList.add('hidden');
        if (cart && cart.classList.contains('is-empty')) {
          cart.classList.remove('is-empty');
        }
      }
    }
  }
  customElements.define('bundle-product', BundleProduct);
}

if (!customElements.get('bundle-manager')) {
  class BundleManager extends HTMLElement {
    connectedCallback() {
      this.addAllButton = this.querySelector('.add-all-to-cart');
      this.subTotalElement = this.querySelector('[data-element="sub-total"]');
      this.bundleProducts = this.querySelectorAll('bundle-product');
      if (this.addAllButton) {
        this.addAllButton.addEventListener('click', this._onAddAllToCart.bind(this));
      }
      this.addEventListener('bundle-product:toggle', this._onProductToggle.bind(this));
      this.updateSubTotal();
      this._observeBundleProducts();
    }

    _onProductToggle(event) {}

    _observeBundleProducts() {
      const observer = new MutationObserver(() => {
        this.updateSubTotal();
      });
      this.bundleProducts.forEach(bundleProduct => {
        observer.observe(bundleProduct, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled', 'class']
        });
      });
    }

    updateSubTotal() {
      if (!this.subTotalElement) return;
      let totalPrice = 0;
      let availableCount = 0;
      let totalCount = 0;
      Array.from(this.bundleProducts).forEach(bundleProduct => {
        totalCount++;
        if (bundleProduct.isAvailable()) {
          totalPrice += bundleProduct.getCurrentPrice();
          availableCount++;
        }
      });
      const currencyFormat = window.theme.settings.money_with_currency_format || "${{amount}}";
      this.subTotalElement.innerHTML = formatMoney(totalPrice, currencyFormat);
      this._updateAddAllButtonState(availableCount, totalCount);
    }

    _updateAddAllButtonState(availableCount, totalCount) {
      if (!this.addAllButton) return;
      this.addAllButton.disabled = availableCount === 0;
      const buttonText = this.addAllButton.querySelector('span') || this.addAllButton;
      if (availableCount === 0) {
        buttonText.textContent = `${window.bundleProductStrings.noAvailableProducts}`;
      } else if (availableCount === totalCount) {
        buttonText.textContent = `${window.bundleProductStrings.addAllToCart} (${totalCount})`;
      } else {
        buttonText.textContent = `${window.bundleProductStrings.addSelectedToCart} (${availableCount}/${totalCount})`;
      }
    }

    getRemovedProducts() {
      return Array.from(this.bundleProducts).filter(product => product.isProductRemoved());
    }
    restoreAllProducts() {
      Array.from(this.bundleProducts).forEach(product => {
        product.restoreProduct();
      });
    }

    async _onAddAllToCart() {
      if (this.addAllButton.disabled) return;
      const spinner = this.addAllButton.querySelector('.loading__spinner');
      this.addAllButton.classList.add('loading');
      this.addAllButton.setAttribute('aria-disabled', true);
      this.addAllButton.disabled = true;
      spinner?.classList.remove('hidden');
      try {
        const availableProducts = Array.from(this.bundleProducts).filter(product => product.isAvailable());
        if (availableProducts.length === 0) {
          throw new Error(window.bundleProductStrings.noAvailableProducts);
        }
        // Validate custom fields của từng sản phẩm
        for (const product of availableProducts) {
          const validation = product._validateCustomFields();
          if (validation.length > 0) throw new Error(validation.join(', '));
        }
        const firstResult = await availableProducts[0].addToCartSilent(1);
        let cart = firstResult.cart;
        let lastData = firstResult.data;
        for (let i = 1; i < availableProducts.length; i++) {
          const result = await availableProducts[i].addToCartSilent(1);
          lastData = result.data;
        }
        if (cart?.renderContents) {
          cart.renderContents(lastData);
        } else {
          window.location = window.routes.cart_url;
        }
        if (cart && cart.classList.contains('is-empty')) {
          cart.classList.remove('is-empty');
        }
      } catch (error) {
        alert(error.message);
      } finally {
        this.addAllButton.classList.remove('loading');
        this.addAllButton.removeAttribute('aria-disabled');
        this.addAllButton.disabled = false;
        spinner?.classList.add('hidden');
        this.updateSubTotal();
      }
    }
  }
  customElements.define('bundle-manager', BundleManager);
}
